"use strict";
// Display mode "Übersicht" (Gerald 10/2026): a plain view for non-experts.
// Every bar spans the full GPfit scale up to 9.0 points (the empty rest is a
// light track) and shows the share reached: points / 9 × 100 (6.3 points =
// 70 %). Shared by the web charts, the map and the dashboard PDF. See
// documentation/charts.md "Übersicht".
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_OVERVIEW_TRACK_OUTLINE = exports.CHART_OVERVIEW_TRACK = exports.CHART_OVERVIEW_TICKS = exports.CHART_OVERVIEW_MAX_POINTS = void 0;
exports.overviewPercent = overviewPercent;
exports.overviewPercentRounded = overviewPercentRounded;
exports.formatOverviewPercent = formatOverviewPercent;
/** Full scale of the Übersicht bars (9.0 GPfit points = 100 %). */
exports.CHART_OVERVIEW_MAX_POINTS = 9;
/** Share of the full scale in % (unrounded; null = no value). */
function overviewPercent(points) {
    if (points === null || points === undefined || !Number.isFinite(points)) {
        return null;
    }
    return (points / exports.CHART_OVERVIEW_MAX_POINTS) * 100;
}
/**
 * Whole percent as shown (round half up): 6.3 -> 70, 9.0 -> 100, 1.0 -> 11,
 * 4.5 -> 50. The quotient is snapped to 9 decimals first, so float noise
 * (e.g. 6.3 / 9 * 100 = 69.99999999999999) cannot flip the rounding.
 */
function overviewPercentRounded(points) {
    const pct = overviewPercent(points);
    if (pct === null)
        return null;
    return Math.round(Math.round(pct * 1e9) / 1e9);
}
/**
 * "70 %" (German: space before the sign, the format of the existing
 * percentages), "70%" in English; "–" without a value.
 */
function formatOverviewPercent(points, language = "de") {
    const pct = overviewPercentRounded(points);
    if (pct === null)
        return "–";
    return language.startsWith("de") ? `${pct} %` : `${pct}%`;
}
/** Axis of the Übersicht bars: 0 … 100 % in 20 % steps. */
exports.CHART_OVERVIEW_TICKS = [0, 20, 40, 60, 80, 100];
/** Fill of the unfilled rest of an Übersicht bar (light track). */
exports.CHART_OVERVIEW_TRACK = "#F1F3F5";
/** Outline of the track (the full 9.0-point scale). */
exports.CHART_OVERVIEW_TRACK_OUTLINE = "#C9CED6";
